import type { IconConfig } from "app/pages/sales-intelligence/modules/lists/types/types";

export const PAGE_SIZE = 10;

export const CUSTOM_ICONS_CONFIG: Record<string, IconConfig> = {
    defaultIcon: {
        iconSize: 32,
        spaceRight: 16,
    },
    listIcon: {
        iconSize: 20,
        spaceRight: 23,
    },
};
